import { render, staticRenderFns } from "./areaWindow.vue?vue&type=template&id=8cec9f9c&scoped=true"
import script from "./areaWindow.vue?vue&type=script&lang=js"
export * from "./areaWindow.vue?vue&type=script&lang=js"
import style0 from "./areaWindow.vue?vue&type=style&index=0&id=8cec9f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cec9f9c",
  null
  
)

export default component.exports